
export const ERROR401: string = 'Por favor verifique que su usuario y contraseña sean correctos.';
export const ERROR500: string = 'Contacte al administrador o intente más tarde.';

export const MONITORIAS_MAIN_VIEW_URL = '/dashboard/home';
export const MONITORIAS_MAIN_ADMIN_URL = '/dashboard/home/admin-view';
export const MONITORIAS_MAIN_COORDINATOR_URL = '/dashboard/home/coordinator-view';
export const MONITORIAS_MAIN_PROFESSOR_URL = '/dashboard/home/professor-view';
export const MONITORIAS_MAIN_STUDENT_URL = '/dashboard/home/student-view';
export const MONITORIAS_MAIN_FINANCIAL_URL = '/dashboard/home/financial-view';
export const NO_AVATAR_URL = 'assets/img/nophoto.png';
export const HOST = window.location.origin;
export const USERS_URL = '/academyuser/services/searchUsers';
export const MONITORIAS_MAIN_HOME_URL = '/dashboard/home/home';
export const TUTORIAL_URL = 'https://new.express.adobe.com/webpage/FTNZPh6rRte0G?';

export const EXTERNAL_SERVICES = 'externalservices';
export const SERVICES = 'services';
export const ESB = 'esb';
export const BANNER = 'banner';
export const GET_MICROSOFT_PROFILE_PICTURE = 'getMicrosoftProfilePicture';



// WEBPACK FOOTER //
// ./src/app/constants.ts